import { T } from '../i18n/RichText';

/**
 * The mark and the wordmark, locked up.
 *
 * The mark is `<img src="/logo.svg">` rather than inline SVG, and that is the
 * point: the same file is the tab icon, so there is exactly one drawing of
 * Cappy in the product and no way for the header and the tab to disagree.
 * Inlining it here would have been a third copy after `CreatureFace.tsx` and
 * the favicon.
 *
 * `alt=""` because the wordmark beside it already says the name. A screen
 * reader that read both would announce "English Tutor English Tutor".
 */
export function Logo({ size = 32 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2">
      <img
        src="/logo.svg"
        alt=""
        width={size}
        height={size}
        // Fixed via width/height as well as CSS: without them the header
        // reflows when the SVG arrives, which on a cold load is the first
        // thing anyone sees move.
        style={{ width: size, height: size }}
        className="shrink-0"
      />
      <span className="text-lg leading-none font-semibold tracking-tight">
        <T k="logo-wordmark" parts={{ accent: (s) => <span className="text-(--tutor-accent)">{s}</span> }} />
      </span>
    </span>
  );
}
